import {
  HStack,
  VStack,
  Heading,
  Text,
  CircleExclamationMarkIcon,
  OutlineCircleInfoIcon,
} from '@frontend/legacy-components';

const VARIANTS = {
  warning: { Icon: CircleExclamationMarkIcon, color: 'alert.warning' },
  info: { Icon: OutlineCircleInfoIcon, color: 'alert.info' },
} as const;

type ExplanationProps = {
  variant: keyof typeof VARIANTS;
  title: string;
  description: string;
};

// A titled item with a status icon: a warning to heed, or information to note.
export const Explanation = ({
  variant,
  title,
  description,
}: ExplanationProps) => {
  const { Icon, color } = VARIANTS[variant];
  return (
    <HStack align="flex-start" py={0.5}>
      <Icon color={color} boxSize={3} />
      <VStack spacing={0} align="stretch">
        <Heading size="md">{title}</Heading>
        <Text size="sm" color="feature.secondary">
          {description}
        </Text>
      </VStack>
    </HStack>
  );
};
